import React, { Component } from "react";
import { PropTypes } from 'prop-types';
import { Tooltip } from "antd";
import {
  ClearFilter,
  TabList,
  TopWrapper,
  TabsContainer,
  TabContent,
  Count,
  Tabtext,
  FilterText
} from "./styles";
import { recordError } from "../../../../utils/commonUtil";

export default class Tabs extends Component {
  state = {
    activeTab: ""
  }

  onClick = (event, key, index) => {
    try {
      this.props.changeTab(key, index);
      if (this.state.activeTab === `${key}`) {
        this.setState({
          activeTab: ''
        });
      } else {
        this.setState({
          activeTab: `${key}`
        });
      }
    } catch (error) {
      recordError(error);
    }
  };

  closeOption = (index, key) => {
    this.props.closeTab(index, key);
    if (this.state.activeTab === `${key}`) {
      this.setState({
        activeTab: ''
      });
    } else {
      this.setState({
        activeTab: `${key}`
      });
    }
  };

  updateStateFunc = (value, id, key, max = 0) => {
    this.props.changeState(value, id, key, max);
  };

  sliderStatus = (value) => {
    this.props.sliderStatus(value)
  }

  geminiFilterData = (data) => {
    this.props.geminiFiltersData(data)
  }

  clearFilter = () => {
    try {
      this.props.clearAllFilters();
    } catch (error) {
      recordError(error);
    }
  };

  render() {
    const { fromPage } = this.props;
    return (
      <TabsContainer data-test ="container">
        <TopWrapper>
          <ClearFilter data-test ="clear-filter" className={window.innerWidth > 767 ? "scrollUp" : ""} onClick={this.clearFilter}>
            { this.props.fromPage === "GA" ? "Clear all filters" : "Clear filters" } {/* bugFix: OW-756 */}
          </ClearFilter>
          <TabList >
            <FilterText> Filters :</FilterText>
            {this.props.config.map((obj, index) => {
              const label = obj.tabName;
              const keyCount = obj.key;
              const toolTip = `Click to view applied filters`;
              return (
                <Tooltip placement="bottomLeft" title={toolTip} key={obj.tabName}>
                  <TabContent
                    data-test="filetrs"
                    id={index+"tbFilters"}
                    key={obj.key}
                    onClick={event => this.onClick(event, obj.key, index)}
                    activeTabStyle={(this.state.activeTab === `${obj.key}`) ? true : false}
                  >
                    <Tabtext>{label}</Tabtext>
                    <Count>{this.props.filtersCounts[keyCount]}</Count>
                  </TabContent>
                </Tooltip>
              );
            })}
          </TabList>
        </TopWrapper>

        {this.props.config.map((obj, index) => {
          const CompName = obj.componentName;
          const showTrue = obj.active;
          if (showTrue) {
            return (
              <CompName
              data-test="configRotate"
                fromPage={fromPage}
                key={obj.key}
                index={index}
                tabFilters={this.props.filtersValues[obj.key]}
                updateStateFunc={(event, id, max, disableFlag) =>
                  this.updateStateFunc(event, id, obj.key, max)
                }
                closeOption={index => this.closeOption(index, obj.key)}
                geminiFilterData={(data) => this.geminiFilterData(data)}
                isFull={this.props.isFull}
                sliderStatus={(value) => this.sliderStatus(value)}
              />
            );
          }
        })}
      </TabsContainer>
    );
  }
}

Tabs.propTypes = {
  changeState: PropTypes.func,
  changeTab: PropTypes.func,
  clearAllFilters: PropTypes.func,
  closeTab: PropTypes.func,
  config: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    activeState: PropTypes.bool,
    componentName: PropTypes.func,
    count: PropTypes.number,
    key: PropTypes.string,
    seletedFilter: PropTypes.string,
    tabName: PropTypes.string,
  })),
  filtersCounts: PropTypes.shape({
    GeminiFilter: PropTypes.number,
    financials: PropTypes.number,
    geography: PropTypes.number,
    organization: PropTypes.number,
  }),
  filtersValues: PropTypes.shape({
    financials: PropTypes.shape({
      form990_total_assets: PropTypes.object,
      form990_total_expenses: PropTypes.object,
      form990_total_revenue: PropTypes.object,
    }),
    geography: PropTypes.shape({
      city: PropTypes.array,
      county: PropTypes.array,
      msa: PropTypes.array,
      radius: PropTypes.number,
      state: PropTypes.array,
      zip: PropTypes.string,
    }),
    organization: PropTypes.shape({
      affiliation_type: PropTypes.object,
      audits: PropTypes.object,
      bmf_status: PropTypes.bool,
      form_types: PropTypes.object,
      foundation_codes: PropTypes.array,
      ntee_major_codes: PropTypes.array,
      ntee_minor_codes: PropTypes.array,
      number_of_employees_range: PropTypes.object,
      profile_levels: PropTypes.array,
      pub78_verified: PropTypes.bool,
      specific_exclusions: PropTypes.object,
      subsection_codes: PropTypes.array,
    }),
  }),
  fromPage: PropTypes.string,
  isActive: PropTypes.string,
  isFull: PropTypes.bool,
  sliderStatus: PropTypes.func,
}